import { render, staticRenderFns } from "./OrganismTicketCreateNewIncident.vue?vue&type=template&id=bd901644&scoped=true&"
import script from "./OrganismTicketCreateNewIncident.vue?vue&type=script&lang=js&"
export * from "./OrganismTicketCreateNewIncident.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTicketCreateNewIncident.vue?vue&type=style&index=0&id=bd901644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd901644",
  null
  
)

export default component.exports